import fill from 'lodash-es/fill';

import type { OrderRatingStarProps } from './OrderRatingStar';
import { OrderRatingStar } from './OrderRatingStar';

export const OrderRatingFiveStars = ({
  isMobile = false,
  onRatingPress,
  rating,
}: Pick<OrderRatingStarProps, 'isMobile' | 'onRatingPress' | 'rating'>) => {
  return (
    <>
      {fill(Array(rating), null).map((_, index) => (
        <OrderRatingStar
          key={`star-${index}`}
          index={index}
          isFilled={true}
          isMobile={isMobile}
          onRatingPress={onRatingPress}
          rating={rating}
        />
      ))}
      {fill(Array(5 - rating), null).map((_, index, array) => (
        <OrderRatingStar
          count={array.length}
          key={`star-empty-${index}`}
          index={index + rating}
          isMobile={isMobile}
          onRatingPress={onRatingPress}
          rating={rating}
        />
      ))}
    </>
  );
};
